import React from 'react'

export default function CreateAdmin() {
  return (
    <>
      <div className="min-h-screen bg-gray-100 pt-10">
        <div className="border bg-white rounded col-lg-4 mx-auto">
          <form className='b m-2 p-3'>
            <div className='title_sign'>
              <h3>Ajouter un admin</h3>
            </div>
            <div className="form-group my-2">
              <label htmlFor="" className="sr-onl block text-gray-700 text-sm font-bold mb-1">
                Nom
              </label>
              <input type="text" className="form-control" placeholder="ndg" />
            </div>
            <div className="form-group my-2">
              <label htmlFor="" className="sr-onl block text-gray-700 text-sm font-bold mb-1">
           Email
              </label>
              <input type="text" className="form-control" placeholder="ndg@havoo.com" />
            </div>
            <div className="form-group my-2">
              <label htmlFor="" className="sr-onl block text-gray-700 text-sm font-bold mb-1">
             Numero de telephone
              </label>
              <input type="text" className="form-control" placeholder="+241 90323..." />
            </div>
            <div className="form-group my-2">
              <label htmlFor="" className="block text-gray-700 text-sm font-bold mb-0">
              Mot de passe
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="------------------"
              />
            </div>
            <div className='text-sm text-center '>
              <p>Vous etes responsable de l'ajout de cet admin.</p>
            </div>
            <div className='my-3 mx-auto'>
              <button className='btn bg-gray-200 btn-block mx-auto font-bold '>Creer un compte</button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
